import { render, staticRenderFns } from "./TzggcxBrowse.vue?vue&type=template&id=e33abf18"
import script from "./TzggcxBrowse.vue?vue&type=script&lang=js"
export * from "./TzggcxBrowse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports